(function () {
  'use strict';

  function initVariantCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.js-variant-cards').forEach(function (grid) {
      if (grid.dataset.vcInit) return;
      grid.dataset.vcInit = '1';

      var picker = grid.closest('variant-picker');
      if (!picker) return;

      var dataScript = picker.querySelector('script[type="application/json"]');
      if (!dataScript) return;

      var parsed = JSON.parse(dataScript.textContent);
      var allVariants = parsed.product.variants;
      var formattedPrices = parsed.formatted;
      var optionSelectors = Array.from(picker.querySelectorAll('.option-selector'));
      var pillsContainers = Array.from(picker.querySelectorAll('.js-variant-pills'));

      function getSelectedOptions() {
        return optionSelectors.map(function (selector) {
          var checked = selector.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function findVariant(options) {
        return allVariants.find(function (variant) {
          return options.every(function (value, index) {
            return value === null || variant.options[index] === value;
          });
        });
      }

      function findCardVariant(currentOptions, optionValue) {
        var options = currentOptions.slice();
        options[0] = optionValue;

        return findVariant(options) || allVariants.find(function (variant) {
          return variant.options[0] === optionValue;
        });
      }

      function setRadioValue(optionIndex, value) {
        var selector = optionSelectors[optionIndex];
        if (!selector) return;

        selector.querySelectorAll('input.js-option').forEach(function (input) {
          input.checked = input.value === value;
        });
      }

      function triggerVariantPickerUpdate() {
        var firstSelector = optionSelectors[0];
        if (!firstSelector) return;

        var checked = firstSelector.querySelector('input:checked');
        if (checked) {
          checked.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      function syncSelectedCard() {
        var selectedOptions = getSelectedOptions();
        var selectedValue = selectedOptions[0];

        grid.querySelectorAll('.variant-card').forEach(function (card) {
          var isSelected = card.dataset.optionValue === selectedValue;
          card.classList.toggle('is-selected', isSelected);
          card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      }

      function syncSelectedPills() {
        var selectedOptions = getSelectedOptions();

        pillsContainers.forEach(function (container) {
          var optionIndex = parseInt(container.dataset.optionIndex, 10) || 1;
          var selectedValue = selectedOptions[optionIndex];

          container.querySelectorAll('.variant-pill').forEach(function (pill) {
            pill.classList.toggle('is-selected', pill.dataset.optionValue === selectedValue);
          });
        });
      }

      function updateCardBadge(card, hasCompare, savingsAmount) {
        var badgeWrapper = card.querySelector('.variant-card__top-badge');
        var savingsBadge = card.querySelector('.js-card-savings');

        if (!badgeWrapper || !savingsBadge) return;

        // Card de 1 unidade nunca mostra "Poupe", mesmo que a variante
        // selecionada nas outras opções tenha comparação de preço.
        if (card.dataset.singleUnit === 'true') {
          badgeWrapper.hidden = true;
          savingsBadge.hidden = true;
          savingsBadge.textContent = '';
          return;
        }

        if (hasCompare) {
          savingsBadge.textContent = 'Poupe ' + (savingsAmount || '');
          savingsBadge.hidden = false;
          badgeWrapper.hidden = false;
          return;
        }

        badgeWrapper.hidden = true;
        savingsBadge.hidden = true;
        savingsBadge.textContent = '';
      }

      function updateCardPrices() {
        var currentOptions = getSelectedOptions();

        grid.querySelectorAll('.variant-card').forEach(function (card) {
          var variant = findCardVariant(currentOptions, card.dataset.optionValue);
          var priceEl = card.querySelector('.js-card-price');
          var compareEl = card.querySelector('.js-card-compare');
          var comparePriceEl = card.querySelector('.js-card-compare-price');

          if (!variant) {
            if (priceEl) priceEl.textContent = '';
            if (compareEl) compareEl.hidden = true;
            if (comparePriceEl) comparePriceEl.textContent = '';
            card.classList.remove('has-savings');
            updateCardBadge(card, false, '');
            return;
          }

          var formatted = formattedPrices[variant.id] || {};
          var hasCompare = !!formatted.hasCompare;
          var savingsAmount = formatted.savingsAmount || '';

          if (priceEl) priceEl.textContent = formatted.price || '';
          if (compareEl) compareEl.hidden = !hasCompare;
          if (comparePriceEl) {
            comparePriceEl.textContent = hasCompare ? (formatted.compareAtPrice || '') : '';
          }

          card.classList.toggle('has-savings', hasCompare);
          updateCardBadge(card, hasCompare, savingsAmount);
        });
      }

      function syncUi() {
        syncSelectedCard();
        syncSelectedPills();
        updateCardPrices();
      }

      grid.addEventListener('click', function (event) {
        var card = event.target.closest('.variant-card');
        if (!card) return;

        setRadioValue(0, card.dataset.optionValue);
        syncUi();
        triggerVariantPickerUpdate();
      });

      pillsContainers.forEach(function (container) {
        var optionIndex = parseInt(container.dataset.optionIndex, 10) || 1;

        container.addEventListener('click', function (event) {
          var pill = event.target.closest('.variant-pill');
          if (!pill) return;

          setRadioValue(optionIndex, pill.dataset.optionValue);
          syncUi();
          triggerVariantPickerUpdate();
        });
      });

      picker.addEventListener('on:variant:change', syncUi);
      syncUi();
      triggerVariantPickerUpdate();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantCards);
  } else {
    initVariantCards();
  }

  document.addEventListener('quickadd:product-rendered', function (event) {
    initVariantCards(event.target);
  });

  window.initVariantCards = initVariantCards;
}());
